import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { OrderSearchParams } from '../types/OrderSearchParams';

export const useSearchOrders = (params: OrderSearchParams) => {
    const { data, isLoading } = useQuery({
        queryKey: ['search-orders', params],
        queryFn: async () => await apiClient.get(`order-search/cfi-orders`,
            {
                params: params
            }) as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
